import { Clickable, Col, Row, Shoutout, ShoutoutsPage, Text } from 'components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ShoutoutsFeed = ({ user, setUser }) => {
  const [data, setData] = useState([]),
    [showPage, setShowPage] = useState(false),
    { t } = useTranslation(),
    isMobile = useSelector((state) => state.appState.isMobile);

  useEffect(() => {
    setData(user.type === 'fan' ? user.sentShoutouts : user.shoutouts);
  }, [user]);

  if (!data?.length) return null;

  if (isMobile)
    return (
      <React.Fragment>
        <ShoutoutsPage visible={showPage} setVisible={setShowPage} data={data} user={user} />

        <Col wid="100%" marg="24px 0 0">
          <Row pad="0 16px" between wid="calc(100% - 32px)" center>
            <Text h2>{t('profile.shoutouts')}</Text>

            <Clickable onClick={() => setShowPage(!showPage)}>
              <Text b2 bold>
                {t('common.seeAll')}
              </Text>
            </Clickable>
          </Row>

          <Row
            start
            style={{ overflowX: 'scroll', overflowY: 'hidden' }}
            wid="100vw"
            marg="8px 0 0"
          >
            {data.map((x, i) => (
              <Row marg={`0 0 0 ${i === 0 ? 16 : 8}px`} key={i}>
                <Shoutout item={x} user={user} />
              </Row>
            ))}
          </Row>
        </Col>
      </React.Fragment>
    );

  return (
    <Col>
      <Text h2>{t('common.shoutouts')}</Text>

      <Row start wrapFlex marg="18px 0 0" gap="24px">
        {data.map((x) => (
          <Shoutout item={x} user={user} />
        ))}
      </Row>
    </Col>
  );
};

export default ShoutoutsFeed;
